import { NgModule } from "@angular/core";
import { SalesTargetRoutingModule } from "./sales-target-routing.module";
import { DetailSalesTargetComponent } from "./detail-sales-target/detail-sales-target.component";
import { AddSalesTargetComponent } from "./edit-sales-target/edit-sales-target.component";
import { SalesTargetListComponent } from "./sales-target-list/sales-target-list.component";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
  declarations: [
    AddSalesTargetComponent,
    SalesTargetListComponent,
    DetailSalesTargetComponent
  ],
  imports: [
    SalesTargetRoutingModule,
    SharedModule
  ],
})
export class SalesTargetModule {}
